var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBodyMale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 502,
    viewBox: "0 0 256 502",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.29 383.384C162.105 384.173 161.316 384.637 160.852 384.73C158.626 385.333 159.043 387.19 159.322 388.489C160.017 391.924 159.785 395.405 159.554 398.794C159.182 404.224 158.255 409.608 157.605 415.039C157.049 419.773 155.889 424.368 154.219 428.778C153.06 431.887 152.782 435.229 151.39 438.246C148.143 445.301 146.891 452.913 144.989 460.293C143.783 464.888 144.154 469.855 144.618 474.636",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9211 383.569C94.1994 383.848 94.4314 384.312 94.756 384.358C97.2607 384.637 97.0288 386.54 96.7505 388.072C96.1012 391.924 96.2867 395.776 96.6114 399.582C97.2144 406.916 98.2812 414.157 99.6263 421.398C100.368 425.296 102.363 428.824 103.105 432.723C104.125 437.968 106.769 442.702 107.883 447.947C108.996 453.192 110.99 458.251 111.5 463.589C111.825 467.116 111.547 470.69 111.547 474.264",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.166 271.523C165.444 278.857 166.094 286.191 165.769 293.524C165.444 300.44 165.12 307.402 162.893 314.086C161.084 319.656 158.997 325.179 157.188 330.749C155.008 337.433 153.385 344.302 152.411 351.311C152.318 351.868 152.411 352.425 152.411 352.935",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8136 271.523C90.5817 278.114 89.9787 284.659 90.2106 291.25C90.4889 300.301 91.2774 309.166 94.3851 317.799C96.1013 322.58 98.1885 327.221 99.3945 332.141C101.018 338.872 103.198 345.509 103.569 352.471",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.82 305.686C112.985 311.348 110.712 316.686 109.738 322.349C108.485 329.45 107.975 336.598 109.506 343.746C110.063 346.438 111.593 348.666 113.634 350.29C116.278 352.333 120.081 350.708 121.38 348.48C121.566 348.155 121.564 348.245 122.029 347.691",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.392 306.103C142.763 310.976 144.433 315.618 145.731 320.259C146.705 323.647 147.03 327.129 147.216 330.563C147.494 335.065 147.633 339.661 146.473 344.116C145.824 346.576 144.433 348.619 142.577 350.29C140.026 352.564 135.573 351.079 134.367 347.644",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9278 194.243C53.4286 201.994 47.0277 208.353 41.8328 215.548C38.2149 220.56 35.3391 225.991 31.8603 231.004C29.1237 234.949 26.016 238.523 22.5837 241.865C21.4705 242.932 19.9862 243.489 18.502 243.954",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M198.469 194.661C200.881 200.045 205.241 204.037 208.72 208.632C213.637 215.177 218.646 221.675 222.589 228.915C225.186 233.743 229.129 237.641 232.839 241.679C234.045 242.979 235.761 243.722 237.524 244.186",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M169.897 225.898C169.897 228.451 169.897 230.958 169.897 233.51C169.851 238.802 170.964 243.907 172.541 248.92C173.932 253.33 174.814 257.925 175.648 262.473C176.391 266.465 177.04 270.503 176.901 274.588C176.854 275.47 176.947 276.398 176.715 277.28",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0824 225.48C86.0824 228.219 86.0824 230.957 86.0824 233.696C86.036 238.43 85.0156 242.933 83.7169 247.481C82.0471 253.19 80.7947 259.038 79.8671 264.933C79.3568 268.368 79.0322 271.756 79.1249 275.237C79.1249 275.794 79.0322 276.351 79.3105 276.862",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M197.634 197.956C202.69 205.29 208.302 212.205 213.822 219.168C217.486 223.763 220.223 228.961 223.284 233.974C225.325 237.316 226.577 240.89 226.577 244.882C226.577 245.763 226.392 246.599 225.928 247.342",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3453 197.956C52.9649 205.382 47.1206 212.484 41.5546 219.771C37.2873 225.341 33.7622 231.375 30.7009 237.687C29.4021 240.379 28.7064 243.536 29.7732 246.692",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5591 123.136C77.4089 126.199 81.8153 127.87 86.6856 128.241C92.3907 128.706 97.6784 126.849 103.152 125.642C107.094 124.76 110.99 123.693 115.072 123.553",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M182.467 123.507C177.736 126.849 172.448 128.705 166.65 128.612C163.357 128.566 160.203 127.638 157.002 126.849C151.715 125.549 146.473 124.11 141 123.739",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M124.534 255.929C122.215 260.756 121.751 266.094 120.267 271.153C118.18 278.254 117.437 285.588 116.927 292.921C116.834 294.035 116.788 295.103 116.742 296.217",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3105 86.0967C81.908 86.6537 84.5055 86.0503 87.1029 86.468C90.7672 87.1178 94.4779 87.6284 98.1886 88.1389C102.409 88.7423 106.63 89.2065 110.712 90.4133C113.541 91.2487 116.324 92.177 119.154 93.0589",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M131.724 256.532C133.115 259.271 133.533 262.241 134.182 265.165C135.388 270.457 137.197 275.609 137.846 280.993C138.403 285.727 138.99 288.899 139.5 293.633M139.5 293.633C139.546 293.958 139.546 293.308 139.5 293.633Z",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.715 86.5133C170.917 85.7243 165.305 87.2096 159.693 87.9986C154.591 88.6948 149.442 89.2518 144.479 90.8299C142.021 91.619 139.47 92.2688 137.058 93.2899",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.329 113.249C153.616 115.988 158.255 119.701 163.728 122.114C170.453 125.085 177.086 124.899 183.673 121.65C183.858 121.557 184.137 121.372 184.09 121.047",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107.651 113.249C103.615 115.152 99.9974 117.844 96.1476 120.026C91.834 122.439 87.2884 124.389 82.1863 124.11C78.5684 123.924 75.0432 123.089 71.8892 121.047",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M126.992 144.903C127.085 149.87 126.297 154.79 126.204 159.71C126.157 163.005 126.343 166.301 126.621 169.55C126.714 170.803 126.668 172.01 126.575 173.263",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M129.033 145.322C128.941 150.149 129.729 154.93 129.822 159.711C129.868 163.146 129.729 166.58 129.358 169.969C129.265 171.083 129.822 172.197 129.219 173.264",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M213.162 203.865C216.594 213.009 221.336 220.978 226.16 229.426C226.392 229.797 226.856 230.261 226.624 230.865",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7605 202.877C39.4209 212.531 34.1332 221.257 29.4021 230.215",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M126.158 175.724C125.74 179.112 126.018 182.454 126.343 185.796C126.621 188.581 126.204 191.319 125.508 194.011C125.091 195.496 125.091 196.889 125.555 198.328",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M129.868 176.142C130.378 179.576 129.961 183.011 129.683 186.399C129.451 189.045 129.961 191.644 130.564 194.197C130.889 195.636 131.028 196.935 130.518 198.328",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M125.74 199.998C125.091 202.087 125.74 204.129 126.018 206.171C126.39 209.003 126.714 211.787 126.761 214.619C126.761 216.197 127.039 217.682 127.596 219.121",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M138.681 259.41C138.495 261.36 140.026 262.566 140.722 264.144C142.763 268.647 144.22 271.725 144.73 276.691",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 200.417C131.028 202.413 130.239 204.409 130.007 206.358C129.683 209.097 129.404 211.835 129.265 214.574C129.219 216.152 128.987 217.637 128.43 219.076",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M122.029 254.258C120.823 255 119.757 255.929 118.736 256.95C117.484 258.203 117.298 259.92 116.649 261.452C115.629 263.773 114.144 265.815 113.356 268.229C112.289 271.478 110.851 274.634 110.712 278.115",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M124.534 87.3494C126.25 84.0539 126.946 80.5728 126.807 76.8596C126.761 74.9566 126.575 73.0072 127.178 71.1041C127.364 70.5472 127.178 70.0366 128.059 70.083C128.848 70.1294 128.801 70.5472 128.894 71.1041C129.497 73.8426 129.173 76.5811 129.265 79.3196C129.358 82.1509 130.147 84.843 131.538 87.3494",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M124.905 66.7871C125.369 71.9856 125.462 77.0912 123.282 82.0112",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M131.074 66.7871C130.703 71.9392 130.425 77.1376 132.698 82.0112",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M102.734 85.3077C99.8117 84.8435 97.0287 83.8688 94.1065 83.4046C92.2976 83.1261 90.535 83.0333 88.7725 82.8477",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M167.253 83.0332C162.429 83.0796 157.837 84.2864 153.292 85.7253",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M149.164 86.3281C144.757 87.5349 140.397 88.8345 136.826 91.8979",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M113.82 409.701C113.727 414.807 115.489 419.17 118.968 422.837C119.246 423.115 119.386 423.394 119.571 423.672",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9583 140.588C90.9991 145.879 94.014 150.567 97.7711 154.791",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M118.968 91.2487C115.258 88.7887 111.176 87.0714 106.862 86.0967",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M167.021 141.005C164.841 146.064 162.244 150.891 158.208 154.79",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M141.775 410.366C141.868 415.75 139.397 420.016 135.593 423.822",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M133.95 254.676C135.666 255.511 137.197 256.625 138.032 258.389C138.449 259.271 139.377 259.132 139.934 259.781C142.624 263.03 145.003 265.708 147.183 269.329",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M116.927 259.41C115.814 259.457 115.211 260.338 114.701 261.081C112.845 263.912 110.387 266.326 108.717 269.297",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M108.903 481.646C108.857 484.987 109.042 488.422 106.445 491.114",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M114.237 482.062C114.191 483.873 115.118 485.451 115.397 487.168C115.675 488.746 115.675 490.092 115.072 491.485",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M112.614 482.479C113.449 485.961 111.918 488.931 110.573 491.948",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M147.123 481.646C146.937 484.987 147.216 488.236 149.164 491.114",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M143.412 482.898C142.624 486.24 143.969 489.118 145.453 491.949",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M141.789 482.479C141.371 484.243 140.954 486.053 140.536 487.817C140.258 489.024 140.119 490.184 140.722 491.298",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M168.691 150.474C166.511 156.136 164.934 162.031 161.502 167.137",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5203 150.659C89.2828 155.626 90.7671 160.685 93.4573 165.28C93.7356 165.744 94.2922 165.93 94.2922 166.487",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9375 159.524C88.3086 161.706 89.0043 163.841 89.2362 166.115C89.2826 166.765 89.329 167.369 89.1898 167.972",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M171.335 156.832C171.242 157.482 170.778 158.085 170.315 158.224C167.346 159.246 167.578 162.031 167.16 164.258C166.929 165.465 166.14 166.811 166.836 168.157",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M137.314 391.182C140.19 392.667 141.488 395.22 142.231 398.19",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M170.129 165.466C170.175 165.976 169.619 166.348 169.479 166.441C166.186 168.065 165.491 171.453 163.96 174.285C163.635 174.842 163.496 175.538 162.708 175.724",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M85.897 165.048C86.0361 165.326 86.0825 165.698 86.3144 165.837C89.3293 167.694 90.6281 170.757 91.8804 173.867C92.1123 174.377 92.5298 174.841 92.9008 175.306",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M118.365 391.182C115.814 391.739 115.072 394.013 114.098 395.962C113.866 396.427 113.309 397.076 113.634 397.773",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M133.95 65.9521C133.393 68.3193 134.646 70.1759 135.573 72.1253",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M122.262 65.9521C122.122 68.1337 121.798 70.2223 120.221 71.8933",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M171.753 139.566C170.593 141.655 168.83 142.769 166.418 142.862",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2271 139.566C85.4794 141.33 86.9637 142.676 89.3756 142.444",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M171.752 146.946C169.943 150.149 167.021 151.216 163.542 151.077",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2271 146.946C84.83 147.55 85.4794 148.153 86.0824 148.803C87.8449 150.752 89.9786 151.17 92.4369 150.659",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6445 156.832C86.1752 158.364 87.5667 160.22 90.2105 159.106",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M124.441 65.8129C123.421 65.488 123.189 64.6526 122.678 63.8171C120.591 60.4752 120.452 56.7156 119.71 53.0488",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M109.042 32.1152C109.506 34.6216 111.732 35.1322 113.588 35.9677C115.814 36.9888 118.133 36.896 120.36 35.5964C121.194 35.1322 122.122 34.9001 123.003 34.5288",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M146.844 32.1152C144.618 35.9213 139.887 37.6386 135.991 35.9677C134.97 35.5499 133.764 35.3179 132.883 34.5752",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M109.877 42.373C111.732 44.2296 113.495 46.1791 115.443 47.8964C117.02 49.2889 117.345 50.7742 116.463 52.6772C116 53.6519 115.768 54.7194 115.397 55.7406",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M145.592 42.79C143.691 44.6466 141.742 46.5032 139.841 48.3598C138.635 49.5202 138.496 50.7734 139.191 52.3051C139.702 53.4655 139.933 54.7651 140.258 55.9719",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M135.759 53.0947C135.388 56.8079 135.202 60.614 132.837 63.7702C132.512 64.2343 132.837 64.4664 132.837 64.8377",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M141.928 37.4531C139.562 39.4954 136.687 40.795 134.136 42.6052C133.672 42.9301 133.115 43.1157 132.512 43.0229",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M113.958 37.8701C116.556 39.5411 119.293 40.9799 121.797 42.7437C122.029 42.8829 122.586 43.7648 123.189 43.0222",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M127.549 58.0146C125.787 59.2214 124.72 60.7995 124.488 62.9346",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M128.569 58.2002C129.868 59.4998 130.842 60.9851 131.445 62.7024",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M176.321 137.014C175.672 137.756 175.904 138.638 175.904 139.474C175.904 145.833 175.95 152.191 174.234 158.365C172.842 163.424 171.219 168.483 169.967 173.589C168.9 177.998 167.091 182.175 166.581 186.724C165.931 192.015 166.813 197.121 168.158 202.134C169.456 206.961 171.219 211.881 170.755 216.708C170.245 221.535 172.379 225.295 173.538 229.472C174.837 234.207 175.857 238.941 176.182 243.861C176.739 252.773 177.249 261.684 176.831 270.596C176.599 275.516 176.321 280.482 175.765 285.402C175.486 287.862 175.625 290.322 175.347 292.782C174.93 296.728 174.141 300.626 173.445 304.479C172.889 307.496 172.518 310.513 171.961 313.53C171.544 315.943 171.033 318.31 170.523 320.724C169.503 325.783 168.436 330.843 167.462 335.948C167.184 337.433 166.72 338.872 166.163 340.218C165.004 342.91 164.54 345.788 163.334 348.48C162.592 350.151 162.963 351.915 162.777 353.632C162.545 355.674 162.545 357.763 162.545 359.805C162.545 363.333 162.128 366.861 161.386 370.295C160.504 374.612 160.922 378.696 162.221 382.874C163.334 386.494 164.818 390.022 165.607 393.735C167.137 401.161 167.833 408.634 166.21 416.153C166.024 416.942 165.607 419 164.822 421.129",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M70.521 121.372C72.7938 123.089 74.3708 125.503 76.2725 127.545C76.5508 127.824 76.7364 128.195 77.1074 128.334C80.1223 129.634 79.6121 132.094 79.1483 134.507C79.0555 134.972 78.87 135.482 79.0091 135.946C80.1223 139.799 79.6121 143.79 79.7049 147.689C79.8904 153.073 81.0964 158.226 82.5343 163.285C84.0649 168.622 85.5028 174.053 87.219 179.344C89.4454 186.167 89.7701 193.037 87.7756 199.906C86.4305 204.501 85.8275 209.282 84.6215 213.923C84.2505 215.409 84.2041 217.173 84.8534 218.843C85.1317 219.54 85.0854 220.607 84.7143 221.489C82.9517 226.131 81.4211 230.865 80.2151 235.692C79.6121 238.106 79.1483 240.612 79.1947 243.072C79.2874 247.76 78.6845 252.401 78.6845 257.043C78.6845 260.338 78.0351 263.634 78.3598 266.929C78.8236 271.803 78.9628 276.677 79.5194 281.55C79.7977 284.196 79.7977 286.888 79.8904 289.58C80.0296 294.175 80.8645 298.677 81.6994 303.133C82.3951 306.846 82.9981 310.559 83.6011 314.273C84.1577 317.522 84.9462 320.678 85.5492 323.927C86.1986 327.64 87.1262 331.307 87.7756 335.02C88.2858 338.037 89.4918 340.822 90.5122 343.653C92.2284 348.341 92.9705 353.076 92.785 358.042C92.5994 363.565 93.759 369.042 94.6403 374.473C94.9186 376.237 94.6403 377.815 94.1765 379.393C92.9241 383.802 91.579 388.165 90.2803 392.575C89.3063 395.777 88.9352 399.119 88.5641 402.415C88.1467 406.035 88.1467 409.563 88.6569 413.09C88.9352 415.04 88.6569 413.09 90.5122 419.947",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M168.297 222.139C166.581 223.949 164.401 225.388 163.427 227.708C162.685 229.472 161.989 231.236 161.293 233C159.113 238.338 156.562 243.49 154.289 248.827C152.016 254.258 150.347 259.874 148.491 265.444C146.775 270.596 144.92 275.748 143.343 280.9C140.467 290.183 137.174 299.327 135.04 308.842C134.344 311.812 134.112 314.876 132.675 317.707C131.979 319.053 132.211 320.956 132.164 322.581C132.118 326.572 132.072 330.518 132.164 334.509C132.35 341.286 132.443 348.062 132.953 354.885C133.556 363.008 134.576 371.084 136.942 378.928C137.174 379.625 137.22 380.367 137.22 381.017C137.406 384.545 139.725 387.144 140.931 390.207C141.673 392.11 141.812 394.013 141.905 395.823C142.23 400.743 142.23 405.71 141.766 410.63C141.719 411.326 141.627 412.022 141.627 412.672C141.766 425.297 140.467 437.875 140.467 450.5C140.467 453.981 139.204 459.326 138.23 462.76",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M132.172 318.883C131.629 316.222 131.7 314.968 131.747 313.807C132.025 307.356 131.422 300.904 131.237 294.499C131.098 289.068 130.263 283.684 129.984 278.254C129.799 274.633 129.613 270.966 128.871 267.346C128.686 266.557 128.546 265.768 127.619 265.722C126.691 265.675 126.923 266.511 126.784 267.114C125.995 270.409 125.81 273.798 125.578 277.186C125.253 281.735 124.789 286.237 124.465 290.786C124.186 295.474 123.908 300.208 123.862 304.942C123.815 309.212 123.908 313.483 122.934 317.706C122.702 318.774 123.166 320.027 123.305 321.187C123.723 325.55 123.676 329.96 123.444 334.323C122.841 345.834 122.795 357.438 120.986 368.856C120.429 372.476 119.455 376.05 118.481 379.531C117.275 383.708 117.461 387.7 118.806 391.692C121.125 398.654 122.285 405.755 121.821 413.089C121.682 415.549 121.079 418.055 120.615 420.469C119.966 423.997 120.012 427.617 119.409 431.144C118.76 434.904 118.62 438.71 118.11 442.423C117.414 447.343 117.09 452.31 117.414 457.23C117.646 460.618 117.043 463.96 117.739 467.302C117.925 468.184 117.693 468.973 116.997 469.808C114.4 472.918 111.477 475.656 108.323 478.209C107.303 479.045 106.236 479.973 106.051 481.458",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5472 257.089C92.9701 261.591 91.5323 266.14 90.651 270.874C89.9552 274.494 89.0276 278.115 88.4246 281.782C87.6361 286.516 87.2186 291.297 87.4969 296.17C87.7752 300.487 87.9607 304.803 88.3782 309.12C88.7956 313.344 89.5378 317.475 90.2335 321.652C90.7901 324.948 90.9757 328.243 91.6714 331.538C92.831 337.155 94.4544 342.632 95.8459 348.155C96.7272 351.636 98.1651 355.024 99.2783 358.459C99.6957 359.759 100.716 360.501 101.319 361.569C104.056 366.535 105.772 371.827 105.215 377.582C105.123 378.418 105.494 379.624 103.963 380.135C103.546 378.232 103.174 376.375 102.757 374.472C101.922 370.388 100.855 366.396 99.9277 362.312C99.8349 361.801 99.371 361.244 99.8813 360.687",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M167.694 224.181C167.74 225.573 167.555 226.919 166.859 228.08C165.236 230.632 164.957 233.51 164.679 236.341C164.122 242.004 163.38 247.667 161.247 252.958C160.087 255.789 161.154 258.203 161.989 260.57C164.401 267.625 165.699 274.912 167.045 282.199C168.529 290.183 167.926 298.213 167.276 306.242C166.72 313.065 165.468 319.795 164.54 326.572C163.241 336.226 160.319 345.509 157.443 354.746C156.84 356.695 156.516 359.109 155.356 360.316C153.408 362.404 152.527 364.864 151.46 367.278C150.022 370.62 149.512 377.257 150.764 379.996C151.46 380.181 151.692 379.439 151.738 379.16C152.712 373.265 154.521 367.556 155.449 361.708C155.495 361.523 155.31 361.29 155.263 361.105",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7308 136.828C77.5712 138.731 77.6176 140.959 77.3856 143.001C76.9218 146.993 75.855 150.799 75.0201 154.698C73.9533 159.571 72.7937 164.445 71.7733 169.319C71.4486 170.757 71.9588 172.196 72.1443 173.635C72.5618 176.652 71.2631 179.205 70.1035 181.851C68.3409 185.889 67.3205 190.252 65.7898 194.383C63.1924 201.206 59.2034 207.286 55.1681 213.32C50.8544 219.818 45.242 225.341 41.1139 231.979C39.676 234.3 38.099 236.481 37.3569 239.173C37.0322 240.426 37.5888 241.401 37.7279 242.469C38.3773 246.971 38.0526 251.287 36.7075 255.65C34.8986 261.545 32.4402 267.161 30.2602 272.87C29.9819 273.613 29.6109 274.356 29.0543 274.959C28.4049 275.655 27.8019 275.841 26.967 275.191C26.2713 274.681 26.2249 274.448 26.5032 273.474C27.7091 269.714 29.3789 266.094 30.6777 262.381",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M176.739 137.014C178.038 139.288 177.945 141.934 178.316 144.44C178.965 148.989 180.403 153.305 181.238 157.808C181.934 161.753 183.743 165.512 183.464 169.504C183.186 174.378 183.743 178.834 185.876 183.336C188.195 188.256 189.355 193.733 191.628 198.746C194.086 204.223 197.518 209.003 200.765 213.923C205.404 220.932 211.341 226.919 215.747 234.067C217.092 236.249 218.576 238.477 217.974 241.262C217.556 243.165 217.463 245.068 217.324 247.017C217.046 250.962 218.437 254.49 219.458 258.11C220.988 263.355 223.493 268.229 225.395 273.334C226.276 275.655 227.157 275.934 229.059 275.005",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M111.014 153.026C111.199 160.546 110.411 167.972 109.761 175.445C109.205 181.943 108.694 188.441 108.973 194.985C109.065 197.678 108.741 200.323 108.88 203.015C109.112 207.703 110.179 212.205 111.06 216.801C111.988 221.535 112.776 226.316 114.075 231.003C115.652 236.62 117.414 242.19 120.476 247.249C120.661 247.527 120.615 247.806 120.661 248.084",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M144.502 153.026C144.456 161.149 145.198 169.225 145.894 177.301C146.126 180.04 146.497 182.778 146.358 185.517C146.126 189.555 146.497 193.593 146.775 197.631C147.146 203.294 146.218 208.817 145.059 214.248C144.085 218.704 143.389 223.206 142.276 227.615C140.513 234.717 138.38 241.633 134.669 247.945",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2542 87.8594C89.6308 89.2982 88.9815 91.3405 88.1929 93.1971C84.5287 101.83 79.612 109.442 71.7269 114.734C66.5783 118.215 62.7285 122.903 59.1106 127.776C57.7191 129.633 57.3017 132.232 56.5595 134.506C54.9361 139.426 55.168 144.625 54.6114 149.684C54.0548 155.161 53.8229 160.824 49.7875 165.372C48.0714 167.275 46.819 169.55 45.4275 171.731C40.9747 178.693 38.1917 186.305 36.3828 194.335C35.3624 198.745 34.5275 203.201 33.136 207.517C32.3938 209.745 31.3734 211.834 30.2602 213.876C28.5904 216.939 28.1729 220.467 27.1989 223.762C26.0393 227.754 24.1376 231.235 20.9835 234.02",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M164.401 87.6738C166.952 91.4799 168.343 95.8429 170.477 99.8345C174.188 106.843 179.661 112.088 185.969 116.637C190.422 119.793 193.947 123.924 196.683 128.473C198.492 131.536 199.327 135.342 199.977 139.055C200.765 143.743 200.719 148.524 201.229 153.258C201.832 158.596 203.687 163.098 206.888 167.229C210.784 172.195 213.66 177.765 215.933 183.66C217.51 187.791 218.576 192.061 219.458 196.378C220.896 203.526 222.03 209.975 225.277 216.52C225.926 217.773 227.286 219.89 227.936 223.438",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6923 228.683C92.5067 229.425 92.8314 230.121 93.1097 230.725C95.9391 237.13 99.0004 243.396 101.691 249.894C103.824 255 105.309 260.384 106.978 265.675C108.741 271.245 110.689 276.769 112.452 282.338C114.724 289.579 117.368 296.727 119.224 304.153C120.198 308.099 120.992 309.709 121.827 313.701C121.919 314.212 122.515 318.085 122.747 318.41",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M138.101 385.751C136.988 391.135 134.947 396.287 134.159 401.764C133.556 406.22 133.37 410.676 133.834 415.132C134.066 417.406 134.391 419.727 134.994 421.908C135.689 424.275 135.365 426.735 135.736 429.103C136.524 434.255 137.034 439.499 137.545 444.698C137.962 449.015 137.777 453.331 137.823 457.648C137.869 460.108 138.426 462.521 137.916 465.074C137.498 467.116 137.359 469.112 135.829 470.876C134.298 472.686 133.602 477.56 134.112 479.88C134.205 480.345 134.483 480.855 134.344 481.319C133.092 485.914 133.37 490.602 133.324 495.29C133.324 495.708 133.277 496.126 133.324 496.543C133.509 497.704 132.303 499.143 133.741 500.025C135.365 500.999 137.266 501.139 139.029 500.767C139.957 500.582 140.792 500.489 141.719 500.628C143.203 500.814 143.806 500.117 143.575 498.586C143.064 495.43 142.044 495.058 139.261 496.961",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M153.501 385.379C150.439 388.164 149.697 392.109 148.166 395.683C146.45 399.628 146.729 403.852 146.543 408.029C146.358 412.903 146.543 417.777 146.497 422.604C146.45 426.642 146.497 430.68 146.265 434.718C145.894 441.355 144.966 447.993 143.389 454.444C142.322 458.9 141.812 463.495 141.163 467.998",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M102.386 385.983C105.494 389.186 106.514 393.456 107.906 397.494C108.741 399.908 108.834 402.507 108.787 405.106C108.741 410.026 109.158 414.993 109.112 419.913C109.065 424.508 109.112 429.103 109.344 433.698C109.715 439.918 110.271 446.091 111.709 452.218C112.915 457.23 113.889 462.382 114.075 467.627",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M122.285 93.8468C119.502 89.9479 117.322 85.7242 115.513 81.3147C114.307 78.437 113.008 75.6057 112.08 72.6351C111.709 71.3819 110.271 72.3102 110.318 71.1963C104.149 74.5846 98.258 78.1121 92.0427 81.1291C88.332 82.9393 84.2039 83.4498 80.3077 84.7959C76.6434 86.0955 72.9791 87.5344 69.6395 89.5302C65.3723 92.083 62.8212 95.9355 61.0122 100.438C59.0641 105.311 57.4871 110.278 56.6986 115.43C56.0492 119.839 56.6986 124.109 58.5539 128.194",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M145.105 71.2432C149.975 73.9352 154.892 76.4881 159.669 79.3194C163.241 81.408 167.091 82.522 170.987 83.636C176.599 85.1676 182.165 86.885 186.989 90.2269C190.839 92.919 193.39 96.957 194.921 101.32C196.544 105.915 198.168 110.557 198.724 115.477C199.234 119.886 198.724 124.203 196.869 128.334",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9648 257.089C96.9129 261.313 98.0262 265.815 99.3249 270.224C100.948 275.748 102.664 281.271 105.169 286.516C107.952 292.411 111.106 298.166 113.24 304.386C115.002 309.538 116.301 314.829 118.017 319.981C119.594 324.623 121.189 328.465 121.653 333.431C121.7 334.127 122.008 335.767 123.131 337.393",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M160.505 257.274C159.345 258.62 159.02 260.431 158.51 262.009C156.655 267.857 155.171 273.845 153.13 279.693C151.645 283.963 149.605 287.955 147.749 291.993C145.616 296.681 143.389 301.276 141.719 306.149C139.354 313.112 137.638 320.259 135.04 327.175C134.113 329.635 133.603 332.116 133.325 334.761C133.189 336.047 132.582 337.072 132.35 337.304",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M149.187 29.47C148.352 27.1956 149.465 25.0141 149.929 22.9255C150.579 19.8157 149.744 17.1236 148.723 14.4779C146.404 8.62966 142.044 4.54515 136.246 2.13157C134.576 1.43534 132.767 1.01761 130.912 1.06402C127.341 1.20327 123.723 0.553459 120.244 1.66742C112.498 4.17383 107.581 9.41872 105.448 17.2628C104.705 20.0477 105.077 22.7398 105.633 25.4783C105.911 26.6851 106.422 27.9383 105.633 29.1915",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M117.136 385.565C114.91 388.072 113.797 391.135 113.704 394.384C113.518 400.975 113.472 407.566 113.704 414.111C114.075 425.297 114.632 436.436 114.817 447.622C114.863 452.357 115.918 459.183 117.31 463.825",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M162.128 394.385C162.035 397.634 162.824 400.836 163.241 404.039C163.798 407.938 163.844 411.883 164.447 415.782C164.818 418.056 164.586 420.331 164.633 422.559C164.679 425.947 163.659 429.057 162.685 432.213C160.829 438.293 158.835 444.327 156.748 450.315C155.634 453.471 154.289 456.488 153.454 459.783C152.48 463.636 151.089 467.442 150.3 471.341C149.929 473.058 150.022 475.008 150.532 476.911C150.81 478.071 150.532 478.491 150.022 480.809",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M178.779 128.381C179.707 130.516 179.011 132.79 179.382 134.972C180.356 140.774 180.681 146.715 182.954 152.238C184.716 156.555 187.128 160.546 190.143 164.167C190.746 164.909 191.581 165.466 192.37 166.023C194.132 167.23 195.988 166.72 197.101 164.817C198.353 162.635 198.678 160.268 199.002 157.808C199.466 154.048 199.559 150.289 199.188 146.483",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M76.458 128.381C76.1797 132.094 75.9014 135.807 75.4839 139.474C74.3707 148.711 71.5413 157.158 65.1868 164.12C63.9345 165.513 62.4966 167.091 60.5021 166.534C58.5076 165.977 57.9046 163.981 57.3944 162.078C56.1885 157.901 55.9565 153.631 56.374 149.314C56.4667 148.386 56.374 147.411 56.374 146.436",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M93.527 394.385C92.7849 399.722 91.9036 405.014 91.4397 410.398C91.2078 413.136 91.0223 415.875 90.744 418.613C90.4193 421.909 90.8368 425.251 91.6717 428.453C93.6661 436.112 96.2172 443.631 99.0002 451.011C101.366 457.231 102.757 463.682 104.891 469.948C105.819 472.64 104.984 475.193 105.03 477.792C105.076 479.138 104.891 478.964 105.819 481.691",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M134.437 352.471C134.808 354.745 135.968 356.462 137.406 358.319C141.116 363.007 143.946 368.252 144.873 374.286C145.291 377.117 144.688 379.948 144.038 382.687C143.714 384.033 142.229 384.219 141.209 383.105C139.817 381.619 139.261 379.67 138.751 377.767C137.684 373.543 136.2 369.412 136.014 365.049C135.875 362.218 134.947 359.479 135.411 356.602",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M119.641 356.787C116.348 359.897 114.26 363.796 112.451 367.88C110.457 372.336 110.225 376.931 111.245 381.666C111.431 382.548 111.616 383.662 112.683 383.894C113.657 384.079 114.214 383.29 114.724 382.501C116.162 380.459 116.394 377.999 117.229 375.725C119.27 370.062 119.687 364.121 120.151 358.226C120.337 356.184 120.197 354.188 121.496 352.471",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M135.04 93.8477C141.209 95.3329 146.589 98.3963 151.645 102.11C156.33 105.498 160.69 109.35 165.05 113.156C168.25 115.988 171.961 117.983 176.321 118.819C180.496 119.562 184.67 120.443 188.706 121.975C190.004 122.486 190.932 123.878 192.602 123.507",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M120.244 93.8477C114.446 95.4258 109.251 98.1642 104.427 101.645C99.7888 104.987 95.1969 108.422 91.1615 112.414C86.4768 116.962 80.7717 118.68 74.6491 119.747C71.4486 120.304 68.3409 121.232 65.4188 122.671C64.723 122.996 64.0737 123.043 63.3315 123.043",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M171.822 134.554C171.822 139.567 171.915 144.579 171.775 149.546C171.497 158.968 169.967 168.158 166.256 176.884",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6938 134.554C83.0444 137.199 83.6474 139.891 83.601 142.583C83.5546 145.693 83.6938 148.896 83.8329 152.052C84.204 159.896 85.6419 167.508 88.4249 174.888C88.6568 175.585 89.0743 176.188 89.0279 176.931",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2193 235.274C23.952 233.603 20.1022 233.975 16.0205 236.388C12.4954 238.477 10.269 241.308 8.46001 244.743C6.92936 247.667 4.79572 250.22 2.70847 252.773C2.3374 253.237 1.87358 253.608 1.50251 254.026C0.945914 254.629 0.899536 255.465 1.13145 256.068C1.45614 256.765 2.3838 256.904 3.12593 256.672C4.65658 256.208 6.23362 255.883 7.48597 254.676C9.063 253.191 10.6864 251.937 11.8924 249.988C13.052 248.085 15.0928 246.785 16.7162 245.207",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M227.296 235.506C231.053 233.51 234.764 233.835 238.382 235.738C242.278 237.734 245.061 240.844 247.056 244.742C248.818 248.177 251.369 251.055 253.828 254.025C254.199 254.49 254.477 254.954 254.709 255.418C253.271 256.81 250.952 256.996 249.328 255.65C248.262 254.814 247.148 254.072 246.174 253.051C245.525 252.354 245.061 251.38 243.948 251.194",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M139.122 60.3359C139.678 61.3571 139.261 62.3318 138.89 63.2137C135.643 70.6865 134.344 78.7163 132.211 86.4676C131.376 89.4845 130.077 92.4087 129.474 95.4721",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M116.347 60.9395C116.116 61.3572 116.162 61.7285 116.347 62.1927C119.502 70.4545 121.357 79.1341 123.537 87.6745C124.233 90.3201 125.439 92.7801 125.995 95.4722",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M106.282 481.552C106.932 481.784 107.488 481.645 107.906 481.135C110.178 478.582 112.544 479.789 114.631 481.181C116.858 482.666 118.759 484.616 121.032 486.101C121.681 486.519 121.867 487.447 121.821 488.143C121.589 491.114 122.377 494.038 122.284 497.008C122.192 500.257 122.099 500.443 118.991 500.907C116.904 501.186 114.91 500.304 112.822 500.629C111.987 500.768 111.245 499.7 111.616 498.679C112.683 495.662 113.008 495.059 116.301 497.008",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5898 224.181C87.6362 226.594 89.2133 228.544 89.8626 230.772C91.0686 235.135 91.0686 239.683 91.9035 244.139C92.4601 247.202 93.3414 250.173 94.2227 253.144C94.5474 254.258 94.872 255.279 94.7793 256.439",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M162.777 228.312C161.85 227.848 161.571 228.73 161.154 229.148C157.768 232.443 154.289 235.692 150.671 238.802C145.801 243.026 140.235 246.275 134.855 249.663C134.484 249.895 134.02 250.034 133.649 250.313C131.793 251.52 131.515 251.52 130.773 249.477C130.17 247.806 129.428 246.135 129.103 244.325",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3579 222.139C88.8886 224.227 90.8367 225.945 92.4137 227.987C93.5269 229.426 95.5678 230.308 97.052 231.747C101.134 235.692 105.169 239.776 109.993 242.84C114.075 245.439 117.971 248.317 122.238 250.545C123.676 251.287 124.001 250.962 124.557 249.848C125.439 248.085 125.81 246.135 126.413 244.279",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3358 251.519C11.5677 251.843 11.7532 252.122 11.7532 252.54C11.7532 256.996 11.846 261.451 11.7068 265.907C11.6141 269.249 11.3821 272.637 11.2894 275.979C11.243 277.418 11.5677 278.764 11.7996 280.064C12.2171 282.292 13.6086 280.574 14.629 280.481",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M110.782 72.0322C110.735 75.1884 110.828 78.3447 110.225 81.5009C109.669 84.1929 107.952 85.5854 105.633 86.3745C104.288 86.8386 103.036 86.1888 102.386 84.9356C101.969 84.0537 102.618 83.2646 103.36 82.7077C105.819 80.8975 107.906 78.7624 109.529 76.1167",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M144.502 72.0322C144.92 74.91 144.595 77.7877 145.105 80.6654C145.569 83.2646 146.822 85.1677 149.234 86.1888C150.811 86.8386 152.248 86.3745 152.898 84.982C153.547 83.5431 152.434 82.8469 151.46 82.1043C149.326 80.4333 147.239 78.716 146.126 76.1632",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M230.775 263.633C231.304 264.893 231.517 265.165 231.749 265.908C233.048 270.549 234.207 275.191 235.228 279.879C235.367 280.482 235.924 280.807 235.924 281.41C233.975 283.128 233.419 283.035 232.027 280.714C230.265 277.836 229.43 274.587 228.317 271.478C227.25 268.507 226.183 265.536 224.838 262.612",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3354 175.027C68.0627 178.369 65.2333 181.201 61.8937 183.428C57.0698 186.631 52.7098 190.391 48.2106 194.011C47.2365 194.8 46.6336 196.239 46.1234 197.446C44.4999 201.437 41.8097 204.733 39.0731 207.889C35.4088 212.066 32.0365 216.225 29.0216 220.867C28.8361 221.145 28.342 221.709 27.7659 222.227",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M185.18 174.842C187.592 179.158 191.396 182.083 195.431 184.728C199.745 187.56 203.595 191.041 207.537 194.382C208.465 195.172 208.882 196.378 209.346 197.492C211.387 202.227 214.773 205.986 218.066 209.792C220.664 212.809 222.797 216.151 225.256 219.261C227.343 221.907 228.688 224.784 229.755 227.941C230.59 230.4 232.677 232.118 234.254 234.114",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M239.17 245.346C240.655 247.017 242.927 248.223 243.53 250.312C243.994 251.89 243.391 253.84 243.484 255.603C243.809 261.545 243.67 267.532 243.994 273.473C244.087 275.423 243.577 277.326 243.901 279.229C244.087 280.296 243.252 280.714 242.696 281.271C241.953 281.039 241.397 280.482 240.608 280.482",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3557 160.871C71.3557 162.403 70.8919 163.888 70.66 165.373C70.3817 167.462 69.5468 169.411 67.4596 170.525C65.2332 171.732 63.0531 173.125 60.8731 174.424C57.5335 176.374 54.8433 179.019 52.0603 181.619",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M184.345 160.871C184.624 164.074 184.485 167.462 187.221 169.922C188.103 170.711 189.169 171.407 190.143 171.918C194.921 174.239 199.095 177.302 202.62 181.247C202.806 181.479 202.992 181.479 203.223 181.433",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M123.955 137.199C118.296 137.013 112.915 138.823 107.303 139.334C104.984 139.52 102.618 139.148 100.299 139.659",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8997 214.944C86.5231 215.037 87.6827 216.104 88.7495 217.033C91.3933 219.307 94.5474 220.653 97.6551 222.092C99.7423 223.067 101.412 222.138 102.386 219.864C103.128 218.193 103.546 216.476 103.824 214.712",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M175.904 130.841C174.28 130.795 173.445 132.233 172.239 132.93C170.152 134.09 168.158 135.715 166.024 136.457C163.241 137.432 160.319 138.175 157.443 138.917C152.202 140.263 147.146 139.149 142.044 138.453C138.612 137.989 135.272 136.921 131.793 137.2",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M149.836 481.181C149.79 484.476 152.109 486.565 153.964 488.746C156.33 491.485 159.716 492.645 162.963 493.945C164.54 494.548 165.328 496.73 164.586 498.447C163.937 499.839 162.823 500.443 161.339 499.7",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M170.384 214.945C167.787 215.641 166.117 217.869 163.844 219.076C161.803 220.143 159.809 221.257 157.675 222.093C155.634 222.882 154.104 222.093 153.176 220.05C152.434 218.426 152.063 216.662 151.738 214.898",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M146.961 46.9685C148.584 47.1077 149.604 45.9474 150.207 44.8798C152.527 40.5632 154.614 36.1074 154.011 30.9089C153.872 29.6093 153.176 28.7738 152.109 28.4953C150.95 28.2169 149.976 29.0059 149.28 29.8878C148.538 30.7697 148.167 31.7444 148.213 32.9512C148.491 38.1032 147.517 43.1625 146.497 48.1289C146.311 49.15 146.311 50.2175 145.94 51.2387C145.337 52.8168 144.641 54.2092 143.296 55.416C140.142 58.2009 137.777 61.8213 134.391 64.3741C131.329 66.6949 127.897 67.3911 124.14 66.2307C123.769 66.1379 123.491 65.9522 123.259 65.7201",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M122.285 65.4883C119.594 64.5135 118.11 62.1 116.208 60.2898C114.399 58.526 112.73 56.6694 110.874 54.9521C109.576 53.6989 109.019 51.6102 108.741 49.7072C107.906 44.1838 106.561 38.7068 107.024 33.0442C107.117 31.7446 106.422 30.5378 105.587 29.6095C104.984 28.9133 104.01 28.3563 102.943 28.5419C101.69 28.8204 101.18 29.9808 100.948 31.0019C100.021 34.9008 103.639 44.6944 106.653 46.6438C107.164 46.9687 107.627 46.9687 108.138 47.0151",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M145.105 54.3486C145.569 55.3233 145.198 56.2516 145.105 57.2264C144.827 61.1252 144.688 65.0241 144.688 68.9229C144.688 69.6656 144.595 70.4546 144.966 71.3365C143.435 71.8935 143.157 73.3324 142.6 74.6784C140.142 80.7587 137.823 86.8855 134.159 92.3625C133.834 92.873 133.695 93.6621 132.953 93.8013",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M201.6 162.913C201.275 166.673 202.481 170.293 202.806 174.006C203.038 176.466 203.595 178.88 203.548 181.386C203.502 183.104 204.754 184.728 205.172 186.492C205.635 188.534 206.331 190.576 207.352 192.479C207.676 193.036 207.444 193.593 207.537 194.15",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8693 162.913C54.1013 165.93 53.4519 168.808 53.0344 171.732C52.5706 174.888 52.4314 178.091 51.7357 181.154C50.9472 184.867 49.7876 188.534 48.3033 192.062C48.0714 192.572 47.6076 193.083 48.1178 193.686",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M236.944 262.009C237.779 265.258 238.15 268.553 238.614 271.895C238.938 274.309 239.449 276.722 240.098 279.089C240.376 280.111 240.284 281.039 240.237 281.967C240.191 282.849 239.866 283.685 238.799 283.824C237.872 283.917 236.99 283.917 236.944 282.617C236.944 282.385 236.573 282.199 236.341 282.014",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2767 263.633C22.7924 269.064 21.4009 274.541 20.2877 280.064C19.963 281.689 18.4788 282.942 17.18 284.102C14.7681 282.849 14.8145 281.039 15.4175 278.858C16.8554 273.52 17.1337 267.996 18.3396 262.612",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M165.839 136.828C165.746 138.824 163.983 139.752 162.87 140.866C159.206 144.626 155.31 148.153 150.439 150.428",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M119.409 490.185C115.188 492.134 110.874 493.155 106.282 491.809C105.076 491.438 103.871 491.113 102.804 490.417",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M153.13 490.185C147.61 493.155 142.09 493.016 136.478 490.37",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M79.751 131.073C80.1684 130.98 80.6786 131.026 80.9569 131.305C81.4208 131.723 81.8382 132.094 82.3948 132.326C87.6825 134.368 90.651 139.103 94.5472 142.816C97.2838 145.415 100.113 147.968 103.546 149.639C104.102 149.917 104.798 149.917 105.215 150.428",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M133.788 51.7028C131.422 49.4285 128.454 49.4285 125.578 49.7534C124.14 49.8926 122.563 50.3568 121.218 51.2851C120.198 51.9349 120.198 52.6775 120.847 53.3738C125.253 57.8296 131.144 56.7156 133.973 53.4202C134.391 52.956 134.53 52.4919 134.159 51.9349C129.845 53.1881 125.485 53.9772 121.218 51.7492",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2906 126.523C61.2906 127.962 60.5484 129.169 60.0382 130.422C58.6467 133.95 57.8582 137.663 56.9769 141.33C56.8841 141.701 57.3016 142.258 56.5594 142.351",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M110.596 55.1846C110.225 57.1804 110.364 59.1298 110.596 61.1257C110.967 64.4676 110.921 67.8559 110.596 71.1977",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M193.808 126.756C196.359 131.815 197.704 137.246 198.724 142.769",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M137.684 469.252C139.771 470.876 140.931 473.383 143.018 475.007C145.244 476.678 147.332 478.489 149.187 480.577",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M135.04 474.589C137.266 475.424 138.843 477.188 141.023 478.534C139.075 480.205 136.895 480.808 134.623 481.18",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6306 136.596C92.8774 137.153 95.846 138.545 99.0928 139.056C99.5103 139.102 99.6958 139.427 99.8813 139.706C102.711 143.697 107.117 145.507 111.199 147.735",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M155.17 139.891C154.475 142.026 152.387 142.768 150.857 143.975C149.001 145.46 146.821 146.435 144.688 147.503",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M143.667 30.5371C140.188 32.3473 136.617 32.3937 132.999 31.1405",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M111.616 30.7236C114.678 32.0697 117.832 32.4874 121.079 31.3734C121.45 31.2342 121.914 31.3734 122.285 31.3734",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M149.604 481.97C148.862 482.063 148.352 481.738 147.749 481.366C144.456 479.231 142.972 479.324 139.957 481.784C138.38 483.084 136.803 484.337 135.225 485.729C134.808 486.101 134.437 486.147 133.973 486.101",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1321 274.959C24.9725 276.862 24.6942 279.136 23.3027 280.947C21.8184 282.85 21.7257 282.989 19.7776 281.736",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M124.743 34.2036C124.557 36.6172 124.094 38.938 123.12 41.2123C122.377 42.9297 122.98 43.6259 125.16 43.8579C125.485 43.9044 125.624 44.1364 125.763 44.2757C126.877 45.4361 127.943 45.6217 129.103 44.3221C129.242 44.1829 129.752 43.8115 130.263 43.8115C132.257 43.7651 132.118 43.7187 131.932 41.7693C131.793 40.0055 130.68 38.6131 130.541 36.8493C130.494 36.0138 130.402 35.0391 130.263 34.1572",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M184.948 121.186C182.444 123.646 180.542 126.755 177.574 128.798C176.46 129.587 176.089 130.654 176.275 132.093C176.507 133.578 176.182 135.11 176.507 136.595",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4434 492.691C97.3302 493.991 96.3562 495.337 94.9647 496.405C93.8979 497.24 94.037 498.725 94.4545 499.607C94.8255 500.443 96.217 500.443 97.1911 500.257C98.2115 500.071 99.0928 499.654 99.0928 498.215C99.0464 495.755 101.134 494.641 102.572 493.063",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M144.085 498.864C144.595 498.632 145.105 499.189 145.291 499.328C147.007 500.953 148.862 500.906 150.903 500.117C151.599 499.839 152.156 500.442 152.759 500.488C154.057 500.628 155.774 500.86 156.377 499.467C156.84 498.353 156.423 496.868 155.634 495.8C154.892 494.826 153.872 494.13 153.176 493.108",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M120.661 474.589C122.238 476.678 121.125 478.952 121.357 481.227C118.899 480.623 116.626 480.438 114.678 478.72C116.116 477.003 117.971 475.982 119.641 474.868C120.847 474.079 120.939 473.29 120.383 472.362C119.687 471.155 119.177 469.762 117.971 468.834",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M111.199 498.864C109.529 499.607 108.277 501.139 106.05 500.582C104.242 500.117 103.917 499.653 104.566 497.843C105.03 496.544 106.468 495.569 106.05 493.944",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M224.606 236.527C222.612 237.873 220.385 238.105 218.02 237.966",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M157.443 493.294C158.417 494.269 159.391 495.197 160.319 496.172C160.597 496.45 160.876 496.682 160.968 497.193C161.154 498.028 161.432 499.003 160.876 499.653C160.134 500.535 158.881 500.349 157.861 500.256C157.443 500.21 157.026 499.746 156.608 499.467",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M122.285 28.8665C120.383 27.6597 118.62 26.0352 116.116 26.1744",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M149.419 493.898C149.512 494.92 149.744 495.894 150.393 496.823C150.996 497.658 151.692 498.633 151.46 499.886",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2806 236.713C33.136 237.734 35.0841 238.291 37.2177 237.734",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M138.751 26.2209C136.431 26.0353 134.901 27.5205 133.185 28.6809",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3214 233C34.8521 234.3 36.8929 234.16 38.6555 234.857",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M221.916 233.231C220.293 234.253 218.391 234.392 216.582 234.856",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M26.364 227.477C27.3844 229.101 28.9151 230.261 30.2602 231.608",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2786 499.469C100.716 501.094 102.34 500.63 104.01 499.887",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M229.337 227.477C227.853 228.498 227.25 230.494 225.441 231.19",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M121.079 481.552C121.45 482.944 122.563 484.29 121.682 485.868",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M94.13 499.654C92.0891 500.257 90.9759 499.468 90.8368 497.379C90.6976 495.43 91.2079 494.269 93.2951 493.62C98.3045 491.995 102.247 488.978 104.891 484.244C105.401 483.362 105.494 482.387 106.051 481.552",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyMale);
export default __webpack_public_path__ + "static/media/body-male.8ba7cd8bd377c6d5bd28a05301b10a61.svg";
export { ForwardRef as ReactComponent };